import { render, staticRenderFns } from "./Urllist.vue?vue&type=template&id=60f615ee&scoped=true"
import script from "./Urllist.vue?vue&type=script&lang=js"
export * from "./Urllist.vue?vue&type=script&lang=js"
import style0 from "./Urllist.vue?vue&type=style&index=0&id=60f615ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f615ee",
  null
  
)

export default component.exports